import { oz } from '@weft/utils';
import { MeasurementPriceSchema } from '../../entities';

export const UpdateMeasurementsPricesMessageSchema = oz.array(MeasurementPriceSchema);

export type UpdateMeasurementsPricesMessage = oz.infer<typeof UpdateMeasurementsPricesMessageSchema>;